<template>
  <div>
    <ul class="list-unstyled">
      <li :class="$style.item" v-show="show == 1">
        <a href="#" :class="$style.itemLink">
          <div :class="$style.itemPic">
            <i class="fe fe-map text-primary"/>
          </div>
          <div class="mr-2">
            <h4 class="">Zahtjev za odmor</h4>
            <div class="text-muted">Podnesite zahtjev za odobrenje</div>
          </div>
          <div :class="$style.itemAction">
            <span/>
          </div>
        </a>
      </li>
      <li :class="$style.item" v-show="show == 2">
        <a href="#" :class="$style.itemLink">
          <div :class="$style.itemPic">
            <i class="fe fe-activity text-danger"/>
          </div>
          <div class="mr-2">
            <h4 class="">Prijava bolovanja</h4>
            <div class="text-muted">Prijavite bolovanje nadređenom</div>
          </div>
          <div :class="$style.itemAction">
            <span/>
          </div>
        </a>
      </li>
      <li :class="$style.item" v-show="show == 3">
        <a href="#" :class="$style.itemLink">
          <div :class="$style.itemPic">
            <i class="fe fe-pause text-warning"/>
          </div>
          <div class="mr-2">
            <h4 class="">Slobodan dan</h4>
            <div class="text-muted">Prijava kraćeg odsustva</div>
          </div>
          <div :class="$style.itemAction">
            <span/>
          </div>
        </a>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: 'KitList5',
  props: ['show'],
}
</script>
<style lang="scss" module>
  @import './style.module.scss';
</style>
